<template>
  <div ref="scrollElement" class="horizontal-scroll" @wheel.exact="onWheel">
    <slot />
  </div>
</template>

<script setup lang="ts">
import { ref, watch, onMounted } from 'vue';
import type { ScrollPos } from '~/interfaces/app';

const props = defineProps({
  scrollPosition: {
    type: Object as () => ScrollPos,
    default: () => ({ value: 0 }),
  },
});

const scrollElement = ref<HTMLElement>();

watch(() => props.scrollPosition.value, scrollTo);

function onWheel(e: WheelEvent) {
  const el = scrollElement.value;
  if (!el || el.scrollWidth <= el.offsetWidth || e.deltaX !== 0) return;

  if (e.cancelable) e.preventDefault();

  const newScroll = el.scrollLeft + e.deltaY;
  el.scrollLeft = Math.max(0, Math.min(newScroll, el.scrollWidth - el.offsetWidth));
}

function scrollTo(pos: number): void {
  const el = scrollElement.value;
  if (!el || el.scrollWidth <= el.offsetWidth) return;

  const maxScroll = el.scrollWidth - el.offsetWidth;
  const targetPos = Math.max(0, Math.min(pos, maxScroll));

  if (
    !props.scrollPosition.width ||
    pos < el.scrollLeft ||
    pos + props.scrollPosition.width > el.scrollLeft + el.offsetWidth
  ) {
    el.scrollLeft = targetPos;
  }
}

onMounted(() => scrollTo(props.scrollPosition.value));
</script>

<style scoped lang="scss" src="./HorizontalScrollScss.scss" />
